var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWordIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12.496 9.295h.864l-.996 4.418L11.069 7.5H8.988L7.48 13.713 6.353 7.5H4.176L6.385 17.5h2.126l1.49-5.913 1.333 5.913h1.96L15.825 7.5h-3.329z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M17.926 4.474a18 18 0 0 0-1.702-1.948A18 18 0 0 0 14.276.824C13.27.085 12.78 0 12.5 0H2.813C1.95 0 1.25.701 1.25 1.563v16.875c0 .86.701 1.562 1.563 1.562h14.375c.86 0 1.562-.701 1.562-1.562V6.25c0-.28-.085-.769-.824-1.776M15.34 3.41c.6.6 1.07 1.14 1.417 1.589H13.75V1.994c.448.347.991.817 1.59 1.417M17.5 18.438c0 .17-.142.312-.312.312H2.813a.316.316 0 0 1-.313-.312V1.563c0-.17.144-.313.313-.313H12.5v4.375a.625.625 0 0 0 .625.625H17.5z"
})));
export default SvgWordIcon;